import { Component, Input, OnInit } from '@angular/core';
import { BenefitPlan } from '@models/benefits/benefit-plan.model';
import { BenefitProvider } from '@models/benefits/benefit-provider.model';
import { BaseForm } from '@forms/base.form';
import { AuthService, FileHelperService } from '@app/services';
import { BenefitPolicy } from '@app/models/benefits/benefit-policy.model';

@Component({
    selector: 'app-form-benefit-plan',
    templateUrl: './benefit-plan.template.html',
})
export class BenefitPlanForm extends BaseForm implements OnInit {
    @Input() benefitPlan: BenefitPlan = new BenefitPlan();

    isLoading = true;

    benefitProviders: BenefitProvider[];
    benefitPolicies: BenefitPolicy[] = [];

    constructor(
        private fileHelper: FileHelperService,
        private auth: AuthService
    ) {
        super();
    }

    ngOnInit(): void {
        this.getBenefitsData();
    }

    beforeShow(): void {
        this.setDefaultProbationPeriodType();
    }

    async saveBooklet(file: File): Promise<void> {
        if (!file) {
            this.benefitPlan.file = null;
            return;
        }

        const storedFile = await this.fileHelper.store(file);
        this.benefitPlan.file = storedFile;
    }

    private setDefaultProbationPeriodType(): void {
        if (!this.benefitPlan.probationPeriodType) {
            this.benefitPlan.probationPeriodType = 'day';
        }
    }

    private async getBenefitsData(): Promise<void> {
        const [benefitPolicies] = await BenefitPolicy.param('company', this.auth.company.id).get();
        const [benefitProviders] = await BenefitProvider.orderBy('name', 'ASC').all();
        this.benefitPolicies = benefitPolicies;
        this.benefitProviders = benefitProviders;
        this.isLoading = false;
    }
}
